/** Seven-digit organization id used across One / Agents tenant APIs. */
export function isDashboardOrgSegment(segment: string): boolean {
  return /^\d{7}$/.test(segment.trim());
}

/** Client: read org id cookie (same name One / Amplify middleware set). */
export function readDashboardOrgCookie(): string | null {
  if (typeof document === "undefined") return null;
  for (const part of document.cookie.split(";")) {
    const t = part.trim();
    if (!t.startsWith("dashboard-org=")) continue;
    const v = t.slice("dashboard-org=".length);
    try {
      const id = decodeURIComponent(v).trim();
      return isDashboardOrgSegment(id) ? id : null;
    } catch {
      const id = v.trim();
      return isDashboardOrgSegment(id) ? id : null;
    }
  }
  return null;
}

/**
 * Host-only cookie on one.atw.net so same-origin /api proxy forwards it to
 * api.one.atw.net, where resolveCrmOrgIdForSession reads it.
 */
export function writeDashboardOrgCookie(orgId: string): void {
  if (typeof document === "undefined") return;
  const id = orgId.trim();
  if (!isDashboardOrgSegment(id)) return;
  const maxAge = 60 * 60 * 24 * 400;
  document.cookie = `dashboard-org=${encodeURIComponent(id)}; path=/; max-age=${maxAge}; SameSite=Lax`;
}
